import request from "../utils/request";

export async function createSafeCashEntry(entry) {
    return request.post("SafeCashEntry/CreateSafeCashEntry", entry);
  }